import { render, staticRenderFns } from "./SpaceSAML.vue?vue&type=template&id=f761a750"
import script from "./SpaceSAML.vue?vue&type=script&lang=js"
export * from "./SpaceSAML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports